export default __webpack_public_path__ + "static/media/Linkedin Learning Resume Writing.3478de10.webp";